module.exports = __webpack_public_path__ + "static/media/temp_3.b1c6f235.jpg";